import React from 'react';
import { DragSource } from 'react-dnd';
import cx from 'classnames';
import { ReactComponent as DragIndicatorIcon } from "../../assets/icons/multiple-files.svg";
import './dragdrop.scss';
import JobUtils from "../../utils/JobsUtils";

const dragHandler = {
  canDrag: function (props) {
    if (JobUtils.skipValidationByJobType(props.jobType)) {
      let canDrag =true;
      (props.fileNames || []).forEach((fileName) => {
        if (new RegExp(/[^a-zA-Z0-9-_. ]/g).test(fileName) && !props.isNoDelivery) {
          props.onDragPrevent();
          canDrag =false;
        }
      })
      return props.canDrag && canDrag;
    } else {
      return props.canDrag
    }
  },
  beginDrag: function (props) {
    return {
      items: props.items,
    };
  },
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

class DragAll extends React.Component {

  getInitialState() {
    return {
      items: this.props.items,
      label: this.props.label,
    };
  }

  state = this.getInitialState();

  componentWillReceiveProps(nextProps) {
    if (nextProps.items !== this.props.items) {
      this.setState({ items: nextProps.items });
    }

    if (nextProps.label !== this.props.label) {
      this.setState({ label: nextProps.label });
    }
  }

  render() {
    let isDragging = this.props.isDragging;
    let connectDragSource = this.props.connectDragSource;
    let itemClasses = cx({
      "drag-item": true,
      dragging: isDragging,
      "dragAllDiv": true
    });

    return connectDragSource(
      <div
        className={itemClasses}
        style={{
            cursor: isDragging ? "grabbing" : "grab",
            opacity: isDragging ? 0.6 : 1}} >
        <DragIndicatorIcon className="dragAllImg"/>
        <span style={{ fontSize: "1.3em" }}>
          {this.state.label}
        </span>
      </div>
    );
  }
}

export default DragSource("items", dragHandler, collect)(DragAll);